import { tv } from "tailwind-variants";

export const UIBannerSlider = tv({
    slots: {
        slider: "tw:flex tw:w-full tw:relative",
        slider_slides: "",
        slider_slides_wrapper: "tw:w-screen tw:max-w-full",
        slider_slides_swiperslide: "tw:flex tw:h-auto",
        slider_slides_slide: "tw:block tw:w-full tw:mb-0",
        slider_navButton: "",
        slider_navButton_icon: "las",
        controls: "tw:flex tw:gap-2 tw:flex-row tw:mb-4 tw:md:mb-0",
        controls_progressBar:
            "tw:flex-1 tw:gap-1 tw:flex tw:justify-center tw:items-center",
        controls_progressBar_bar: [
            "tw:group tw:p-0 tw:h-3.5! tw:transition-all tw:duration-300 tw:rounded-full tw:focus:rounded-full! tw:hover:rounded-full!",
            "tw:hover:ring-3 tw:hover:ring-primary/50! tw:hover:border-none!",
            "tw:focus:ring-primary/50! tw:focus:border-none!"
        ],
        controls_progressBar_bar_content:
            "tw:animation-delay-[300ms] tw:after:animation-delay-[300ms]",
        controls_button: "tw:inline-block",
        controls_button_icon: "las"
    },
    variants: {
        type: {
            left: {
                slider_navButton_icon: "la-angle-left"
            },
            right: {
                slider_navButton_icon: "la-angle-right"
            }
        },
        isRunning: {
            true: {
                controls_progressBar_bar: "tw:w-14",
                controls_button_icon: "la-pause"
            },
            false: {
                controls_progressBar_bar: "tw:w-3.5",
                controls_button_icon: "la-play"
            }
        }
    }
});
